import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { useAuth } from '../authContext';
import { theme } from '../lib/theme';

export default function MarketplaceAdminDash() {
  const { profile, signOutUser } = useAuth();
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [applications, setApplications] = useState([]);
  const [tab, setTab] = useState('bookings');
  const [loadError, setLoadError] = useState('');
  const [actionError, setActionError] = useState('');
  const [reviewingId, setReviewingId] = useState(null);

  async function load() {
    setLoadError('');
    const [b, a] = await Promise.all([
      supabase.from('bookings').select('*').order('created_at', { ascending: false }).limit(50),
      supabase.from('driver_applications').select('*').order('created_at', { ascending: false }),
    ]);
    if (b.error || a.error) {
      setLoadError(b.error?.message || a.error?.message || 'Could not load data.');
    }
    setBookings(b.data || []);
    setApplications(a.data || []);
  }

  useEffect(() => {
    load();
  }, []);

  const updateBooking = async (id, status) => {
    setActionError('');
    const { error } = await supabase.from('bookings').update({ status }).eq('id', id);
    if (error) {
      setActionError(error.message);
      return;
    }
    load();
  };

  const reviewApplication = async (id, approve) => {
    setActionError('');
    setReviewingId(id);
    const { error } = await supabase.rpc('review_marketplace_driver_application', {
      p_application_id: id,
      p_approve: approve,
    });
    setReviewingId(null);
    if (error) {
      setActionError(error.message);
      return;
    }
    load();
  };

  return (
    <div style={{ minHeight: '100vh', background: theme.bg, color: theme.text, fontFamily: theme.font }}>
      <header style={{ padding: '16px 24px', borderBottom: '1px solid rgba(255,255,255,0.07)', display: 'flex', justifyContent: 'space-between' }}>
        <span style={{ fontWeight: 700 }}>Marketplace admin</span>
        <button type="button" onClick={async () => { await signOutUser(); navigate('/'); }} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.12)', color: theme.muted, padding: '6px 12px', borderRadius: 8, cursor: 'pointer' }}>
          Sign out
        </button>
      </header>
      <main style={{ maxWidth: 900, margin: '0 auto', padding: 24 }}>
        <p style={{ color: theme.muted, fontSize: 14, marginBottom: 20 }}>{profile?.email}</p>
        {loadError ? <p style={{ color: '#f87171', marginBottom: 16 }}>{loadError}</p> : null}
        {actionError ? <p style={{ color: '#f87171', marginBottom: 16 }}>{actionError}</p> : null}
        <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
          {['bookings', 'applications'].map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setTab(t)}
              style={{
                padding: '8px 16px',
                borderRadius: 8,
                border: tab === t ? `2px solid ${theme.accent}` : '1px solid rgba(255,255,255,0.1)',
                background: 'transparent',
                color: theme.text,
                cursor: 'pointer',
                textTransform: 'capitalize',
              }}
            >
              {t}
            </button>
          ))}
        </div>

        {tab === 'bookings' &&
          bookings.map((b) => (
            <div key={b.id} style={{ background: theme.bg1, borderRadius: 10, padding: 14, marginBottom: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
              <div>
                <strong>{b.passenger_name || 'Guest'}</strong>
                <p style={{ margin: '4px 0 0', fontSize: 13, color: theme.muted }}>
                  {b.package} · {b.area} · ₦{Number(b.price || 0).toLocaleString()}
                </p>
              </div>
              <select value={b.status} onChange={(e) => updateBooking(b.id, e.target.value)} style={{ background: theme.bg2, color: theme.text, border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: 6 }}>
                {['pending', 'confirmed', 'in_progress', 'completed', 'cancelled'].map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
          ))}

        {tab === 'applications' &&
          applications.map((a) => (
            <div key={a.id} style={{ background: theme.bg1, borderRadius: 10, padding: 14, marginBottom: 10 }}>
              <strong>{a.full_name}</strong>
              <span style={{ marginLeft: 10, fontSize: 12, color: theme.accentLight }}>{a.status}</span>
              <p style={{ fontSize: 13, color: theme.muted, margin: '6px 0' }}>{a.email} · {a.phone}</p>
              {a.status === 'pending' && (
                <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                  <button type="button" disabled={reviewingId === a.id} onClick={() => reviewApplication(a.id, true)} style={{ flex: 1, padding: 8, background: theme.accent, color: '#fff', border: 'none', borderRadius: 8, cursor: reviewingId === a.id ? 'wait' : 'pointer' }}>
                    Approve
                  </button>
                  <button type="button" disabled={reviewingId === a.id} onClick={() => reviewApplication(a.id, false)} style={{ flex: 1, padding: 8, background: 'rgba(248,113,113,0.15)', color: '#f87171', border: 'none', borderRadius: 8, cursor: reviewingId === a.id ? 'wait' : 'pointer' }}>
                    Reject
                  </button>
                </div>
              )}
            </div>
          ))}
        <p style={{ marginTop: 32, fontSize: 13, color: theme.dim }}>
          <Link to="/" style={{ color: theme.muted }}>← Public site</Link>
        </p>
      </main>
    </div>
  );
}
